// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yORn","rootNoMargin":"styles_rootNoMargin__1Ji1t"};